import * as echarts from 'echarts';
import { numberDivide } from '@/utils/utils';
/**课程访问统计 */
export function visitStatistics(id, xData, yData) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    option = {
        xAxis: {
            type: 'category',
            data: xData,
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        tooltip: {
            trigger: 'axis' // 触发类型：坐标轴触发
        },
        yAxis: {
            type: 'value',
            minInterval: 1, // 设置 y 轴的最小间隔值为 1
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        series: [
            {
                data: yData,
                type: 'line',
                smooth: true,
                lineStyle: {
                    color: '#387DFF'
                },
                itemStyle: {
                    normal: {
                        label: { show: true },
                        color: '#8590B3', // 设置圆点颜色
                        borderColor: '#387DFF', // 设置圆点边框颜色
                        borderWidth: 2 // 设置圆点边框宽度
                    }
                },
            }
        ]
    };
    option && myChart.setOption(option);
    return myChart;
}
/**新增课程统计 */
export function courseStatistics(id, xData, yData) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    option = {
        tooltip: {
            trigger: 'axis' // 触发类型：坐标轴触发
        },
        xAxis: {
            type: 'category',
            data: xData,
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        yAxis: {
            type: 'value',
            minInterval: 1, // 设置 y 轴的最小间隔值为 1
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        series: [
            {
                data: yData,
                type: 'line',
                lineStyle: {
                    color: '#387DFF'
                },
                itemStyle: {
                    normal: {
                        label: { show: true },
                        color: '#8590B3', // 设置圆点颜色
                        borderColor: '#387DFF', // 设置圆点边框颜色
                        borderWidth: 2 // 设置圆点边框宽度
                    }
                },
            }
        ]
    };
    option && myChart.setOption(option);
    return myChart;
}
/**课程收藏统计 */
export function collectStatistics(id, xData, yData) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    option = {
        tooltip: {
            trigger: 'axis' // 触发类型：坐标轴触发
        },
        xAxis: {
            type: 'category',
            data: xData,
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        yAxis: {
            type: 'value',
            minInterval: 1, // 设置 y 轴的最小间隔值为 1
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        series: [
            {
                data: yData,
                type: 'line',
                smooth: true,
                lineStyle: {
                    color: '#387DFF'
                },
                itemStyle: {
                    normal: {
                        label: { show: true },
                        color: '#8590B3', // 设置圆点颜色
                        borderColor: '#387DFF', // 设置圆点边框颜色
                        borderWidth: 2 // 设置圆点边框宽度
                    }
                },
                // 在这里设置区域渐变样式
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            {
                                offset: 1, color: '#ffffff' // 0% 处的颜色
                            },
                            {
                                offset: 0, color: '#9bbeff' // 100% 处的颜色
                            }
                        ],
                        global: false // 缺省为 false
                    }
                }
            }
        ]
    };
    option && myChart.setOption(option);
    return myChart;
}
/**新增资源统计 */
export function resourceStatistics(id, xData = [], yData = {}) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    option = {
        tooltip: {
            trigger: 'axis' // 触发类型：坐标轴触发
        },
        color: ['#387DFF', '#86B9FF', '#555CF7', '#D5698A', '#FE7C4B', '#EAD656', '#24B89A', '#8F98A9'],
        xAxis: {
            type: 'category',
            data: xData,
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        legend: {
            left: 'center',
            top: '90%',
            itemGap: 20 // 设置图例项之间的间隔为20
        },
        yAxis: {
            type: 'value',
            minInterval: 1, // 设置 y 轴的最小间隔值为 1
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        series: [
            {
                name: '软件',
                data: yData['软件'],
                type: 'line',
                smooth: true,
            },
            {
                name: '模型',
                data: yData['模型'],
                type: 'line',
                smooth: true,
            },
            {
                name: '视频',
                data: yData['视频'],
                type: 'line',
                smooth: true,
            },
            {
                name: '动画',
                data: yData['动画'],
                type: 'line',
                smooth: true,
            },
            {
                name: '课件',
                data: yData['ppt'],
                type: 'line',
                smooth: true,
            },
            {
                name: '试卷',
                data: yData['试卷'],
                type: 'line',
                smooth: true,
            },
            {
                name: '图片',
                data: yData['图片'],
                type: 'line',
                smooth: true,
            },
            {
                name: '文档',
                data: yData['文档'],
                type: 'line',
                smooth: true,
            },
        ]
    };
    option && myChart.setOption(option);
    return myChart;
}
/**分类资源使用统计 */
export function categoryStatistics(id, xData = [], last = [], current = []) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    option = {
        tooltip: {
            trigger: 'axis' // 触发类型：坐标轴触发
        },
        xAxis: {
            type: 'category',
            data: xData,
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLabel: {
                rotate: -15 // 旋转角度
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        yAxis: {
            type: 'value',
            minInterval: 1, // 设置 y 轴的最小间隔值为 1
            splitLine: {
                show: true, // 显示x轴分割线
                lineStyle: {
                    color: '#EAEBF0', // x轴网格线颜色
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8590B3' // 修改为你想要的颜色
                }
            }
        },
        legend: {
            left: 'center',
            top: '90%',
            height: '40%',
            itemGap: 20 // 设置图例项之间的间隔为20
        },
        series: [
            {
                name: '上月使用',
                data: last,
                type: 'bar',
                barWidth: '16',
                label: { show: true, color: '#8590B3', position: 'top' },
                itemStyle: {
                    barBorderRadius: [10, 10, 0, 0], // 这里设置圆角的大小
                    color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1, // x1, y1, x2, y2 指定渐变的起点和终点位置
                        [
                            { offset: 1, color: '#72bbff' },   // 0% 处的颜色
                            { offset: 0, color: '#387dff' }   // 100% 处的颜色
                        ]
                    )
                }
            },
            {
                name: '本月使用',
                data: current,
                type: 'bar',
                barWidth: '16',
                label: { show: true, color: '#8590B3', position: 'top' },
                itemStyle: {
                    barBorderRadius: [10, 10, 0, 0], // 这里设置圆角的大小
                    color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1, // x1, y1, x2, y2 指定渐变的起点和终点位置
                        [
                            { offset: 1, color: '#72BBFF' },   // 0% 处的颜色
                            { offset: 0, color: '#9BBEFF' }   // 100% 处的颜色
                        ]
                    )
                }
            },
        ]
    };

    option && myChart.setOption(option);
    return myChart;
}
/**分类资源使用占比 */
export function categoryUserChart(id, data) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        color: ['#387DFF', '#80B6FF', '#23B899', '#EAD656', '#8F98A9'],
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            top: 'center',
            itemGap: 20 // 设置图例项之间的间隔为20
        },
        series: [
            {
                name: '分类资源使用占比',
                type: 'pie',
                radius: '50%',
                center: ['60%', '50%'], // 设置饼图的中心位置
                data: data || [],
                label: {
                    normal: {
                        show: true,
                        position: 'inside', // 在饼图内部显示标签
                        formatter: '{d}%' // 显示名称和百分比
                    }
                },
                minInterval: 1, // 设置 y 轴的最小间隔值为 1
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };

    option && myChart.setOption(option);
    return myChart;
}
/**资源占比 */
export function resourceRateChart(id, data, total = 0) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
        color: ['#387DFF', '#86B9FF', '#555CF7', '#D5698A', '#FE7C4B', '#EAD656', '#24B89A', '#8F98A9'],
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            top: 'center',
            height: '40%',
            itemGap: 20 // 设置图例项之间的间隔为20
        },
        title: {
            text: numberDivide(total),//主标题文本
            subtext: '资源总量',//副标题文本
            left: '55%',
            top: '42%',
            align: 'center',
            textStyle: {
                fontSize: 16,
                color: '#454c5c',
            },
            subtextStyle: {
                fontFamily: "微软雅黑",
                fontSize: 14,
                color: '#6c7a89',
                align: 'center'
            }
        },
        series: [
            {
                name: '资源占比',
                minInterval: 1, // 设置 y 轴的最小间隔值为 1
                type: 'pie',
                radius: ['30%', '50%'],
                center: ['60%', '50%'], // 设置饼图的中心位置
                avoidLabelOverlap: false,
                label: {
                    normal: {
                        show: true,
                        position: 'bottom',
                        formatter: '{d}%' // 显示名称和百分比
                    }
                },
                labelLine: {
                    show: true
                },
                data: data || []
            }
        ]
    };

    option && myChart.setOption(option);
    return myChart;
}
/**平台用户角色分布 */
export function userRoleDistribution(id,data) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    option = {
        color: ['#25B89A', '#387DFF', '#EAD656'],
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '85%',
            left: 'center',
            itemGap: 60,
            itemHeight: 10,
            itemWidth: 10,
        },
        series: [
            {
                type: 'pie',
                radius: ['35%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    position: 'top', // 标签位置
                    formatter: '{c}',// 显示格式，{b}是数据项名称，{c}是数值，{d}是百分比
                    color: '#334681',
                },
                labelLine: {
                    show: true,
                    normal: {
                        show: true,
                        length: 20,  // 引导线的长度
                        length2: 30, // 引导线的第二段长度
                        smooth: 0.2, // 引导线平滑度
                    }
                },
                emphasis: {
                    label: {
                        show: true,
                    }
                },
                data: data||[]
            }
        ]
    };

    option && myChart.setOption(option);
    return myChart;
}
/**平台用户增长量 */
export function userAddNumber(id,currentData,addData,xData) {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    var series = [
        {
            data: currentData||[],
            type: 'bar',
            stack: 'a',
            barWidth: '15', // 设置柱状图的宽度为类目宽度的50%
            name: '上月用户量',
        },
        {
            data: addData||[],
            type: 'bar',
            stack: 'a',
            barWidth: '15', // 设置柱状图的宽度为类目宽度的50%
            itemStyle: {
                barBorderRadius: [10, 10, 0, 0]
            },
            label: {
                show: true,
                color: '#8590B3',
                position: 'top', // 显示位置
                formatter: function (params) {
                    var current=currentData[params.dataIndex];
                    return current;
                    // var last=current-params.data;
                    // if(last)
                    // return (params.data/last*100).toFixed(1)+'%';
                    // else 
                    // return '0%'
                }
            },
            name: '当月新增用户'
        },
    ];
    option = {
        color: ['#387DFF', '#88B1FF'],
        tooltip: {
            // 触发类型，默认数据触发，可选为：'item' | 'axis'
            trigger: 'axis',
            backgroundColor: 'rgba(245,248,255,0.81)',
            formatter:function(params){
                var lastUser=params[0].data-params[1].data;
                return `<div style='color:#8590B3;'>
                            <div style='display:flex;align-items:center;'>
                                <div style='width:6px;height:6px;background-color:#88B1FF;margin-right:5px;'></div>
                                <div>上月用户量</div>
                            </div>
                            <div style='color:#88B1FF;font-weight:700;'>${lastUser}</div>
                            <div style='display:flex;align-items:center;'>
                                <div style='width:6px;height:6px;background-color:#387DFF;margin-right:5px;'></div>
                                <div>当月新增用户</div>
                            </div>
                            <div style='color:#387DFF;font-weight:700;'>${params[1].data}</div>
                        </div>
                        `
            }
        },
        xAxis: {
            axisTick: {
                show: false // 不显示坐标轴刻度线
            },
            axisLine: {
                show: false, // 不显示坐标轴线
            },
            axisLabel: {
                color: '#8590B3' // 设置Y轴标签文字颜色为蓝色
            },
            type: 'category',
            data: xData||[ ]
        },
        yAxis: {
            axisTick: {
                show: false // 不显示坐标轴刻度线
            },
            axisLine: {
                show: false, // 不显示坐标轴线
            },
            axisLabel: {
                color: '#8590B3' // 设置Y轴标签文字颜色为蓝色
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#F0F0F0', // 设置 x 轴网格线颜色
                    type: 'solid' // 设置网格线类型，默认为实线，可选：'solid', 'dashed', 'dotted'
                }
            },
            type: 'value'
        },
        series: series
    };

    option && myChart.setOption(option);
    return myChart;
}